module.exports = __webpack_public_path__ + "static/media/15.031afb8f.jpeg";